
/**
 * 檔案相關Enum
 */
export namespace FILE_ENUM {

    export const FILE_EXT_TYPE = {
        PNG: {
            CODE: 1,
            EXT: 'png'
        },
        SVG: {
            CODE: 2,
            EXT: 'svg'
        },
        PDF: {
            CODE: 3,
            EXT: 'pdf'
        },
        XLSX: {
            CODE: 4,
            EXT: 'xlsx'
        },
        DXF: {
            CODE: 5,
            EXT: 'dxf'
        }
    }
}